import { render, staticRenderFns } from "./SubKategoriPenyaluranPopup.vue?vue&type=template&id=4c048ede"
import script from "./SubKategoriPenyaluranPopup.vue?vue&type=script&lang=js"
export * from "./SubKategoriPenyaluranPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports